
function enableCandidat(evt) {
    evt.preventDefault();
    var url = $(this).attr('href');
    modalOuiNon('Êtes vous sur de vouloir activer ce compte ?', 'Attention', function() {
        document.location.href = url;
    });
}

function disableCandidat(evt) {
    evt.preventDefault();
    var url = $(this).attr('href');
    modalOuiNon('Êtes vous sur de vouloir désactiver ce compte ?', 'Attention', function() {
        document.location.href = url;
    });
}

function archiveCandidat(evt) {
    evt.preventDefault();
    var url = $(this).attr('href');
    modalOuiNon('Êtes vous sur de vouloir archiver ce dossier ?', 'Attention', function() {
        document.location.href = url;
    });

    return false;
}

function unarchiveCandidat(evt) {
    evt.preventDefault();
    var url = $(this).attr('href');
    modalOuiNon('Êtes vous sur de vouloir désarchiver ce dossier ?', 'Attention', function() {
        document.location.href = url;
    });

    return false;
}

function hasAjaxErrors(response, $modal) {
    if(response.msg != undefined && response.msg.errors !== undefined) {

        $modal.modal('show');
        for (field in response.msg.errors) {
            var $label = $modal.find('label[for=' + field + ']');
            var $error = $('#' + field + '_error');
            $label.addClass('red-text');
            $error.html(response.msg.errors[field]);
            setTimeout(function() {
                $label.removeClass('red-text');
                $error.html('');
            }, 5000);
        }
        return true;
    }
    return false;
}

function openModalAddPrivateNote(e)
{
    e.stopImmediatePropagation();
    var $project = $(e.currentTarget);
    var lpUuid = $project.data('lp-uuid');
    var privateNote = StringHelper.base64decode($project.data('privatenote'));

    if(privateNote) {
        $('tr[data-lp-uuid="' + lpUuid + '"]').find('button.privateNote').click();
        return;
    }

    var $modalConfirmAddPrivateNote = $('#modal-confirm-add-private-note');
    var $privateNote   = $('#modal-confirm-add-private-note #private_note');

    $('#btn-add-private-note-confirm-spinner').hide();

    $privateNote.val(privateNote);
    $modalConfirmAddPrivateNote.modal();

    $('#btn-add-private-note-confirm' ).off().on('click', function () {
        var note = $privateNote.val();
        if(note !== undefined && note.trim()) {
            ajaxPrivateNote(note, lpUuid, {
                stop: function (response) {
                    $('#btn-add-private-note-confirm-spinner').hide();
                    $('#btn-add-private-note-confirm, #btn-add-private-note-cancel').show();
                    if (!hasAjaxErrors(response, $modalConfirmAddPrivateNote)) {
                        Util.getCsrf();
                        $privateNote.val('');
                        $project.data('privatenote', StringHelper.base64encode(note));
                        $project.attr('title', 'Modifier la note privée');
                        $project.find('span').html('Modifier la note privée');

                        $('#btn-candidature-non-retenue-confirm').removeAttr('disabled');
                        // Flag
                        var $button = $('tr[data-lp-uuid="' + lpUuid + '"]').find('button.privateNote');
                        $button.removeClass('hide');
                        $button.attr('data-original-title', note.replace(/"/g, "&quot;"));
                        $modalConfirmAddPrivateNote.modal('hide');

                    } else {
                        $('#btn-add-private-note-confirm').attr('disabled', 'disabled');
                    }
                }, start: function () {
                    $('#btn-add-private-note-confirm, #btn-add-private-note-cancel').hide();
                    $('#btn-add-private-note-confirm-spinner').show();
                }
            });
        } else {
            $modalConfirmAddPrivateNote.modal('hide');
        }
    });
}


function ajaxPrivateNote(note, lpUuid, callback) {
    var url = '/candidats/ajaxProjectAddPrivateNote';
    var csrf = candidatLocataireCRUD.getCsrf();
    var data = {
        private_note: note,
        lpuuid: lpUuid
    };
    callback.start();
    data[csrf.name] = csrf.value;
    $.ajax({
        type: 'POST',
        url: PROFIL + url,
        data: data,
        dataType: 'json'
    }).done(function (response) {
        callback.stop(response);
    });

}

function openModalRefuseProc(e)
{
    var upid = $(e.currentTarget).data('upid');
    var $modalConfirmRefuse = $('#modal-confirm-refuse-proc');
    var $refusCommentaire   = $('#modal-confirm-refuse-proc #refus_commentaire');

    $refusCommentaire.val('');
    $modalConfirmRefuse.modal();

    $('.btn-refuse-proc').off().on('click', function () {
        var data = {
            commentaire: $refusCommentaire.val()
        };
        $.post(PROFIL + '/candidats/refuseProc/' + upid, data, function (data) {
            $modalConfirmRefuse.modal('hide');
            candidatLocataireCRUD.refresh();
        });
    });
}

function delay(callback, ms) {
    var timer = 0;
    return function() {
        var context = this, args = arguments;
        clearTimeout(timer);
        timer = setTimeout(function () {
            callback.apply(context, args);
        }, ms || 0);
    };
}

function openModalCandidatureNonRetenue(e)
{
    var $project = $(e.currentTarget);

    var lpUuid = $project.data('lpuuid');
    var contactId = $project.data('contactid');
    var contactName = $project.data('contactname');
    var $modalConfirmRefuse = $('#modal-confirm-candidature-non-retenue');
    var $refusCommentaire   = $('#modal-confirm-candidature-non-retenue #refus_commentaire');
    var hidePreview = true;

    $refusCommentaire.keyup(delay(function (e) {
        if(hidePreview == false) {
            $('#btn-candidature-non-retenue-preview').click();
        }
    }, 500));

    $('#btn-candidature-non-retenue-confirm-spinner, #btn-candidature-non-retenue-preview-spinner').hide();
    $('#modal-confirm-candidature-non-retenue h3 span').html(contactName);
    $refusCommentaire.val("nous avons le regret de vous indiquer qu'un autre dossier a été retenu par le propriétaire");
    $modalConfirmRefuse.modal();

    // Masquer la prévisualisation
    $('#previewHeader, #hidePreview').hide();
    $('#btn-candidature-non-retenue-preview').show();

    $('#hidePreview').off().on('click', function (e) {
        e.stopImmediatePropagation();
        hidePreview = true;
        $('#btn-candidature-non-retenue-preview').show();
        $('#previewHeader, #hidePreview').hide();
    });

    function appelCandidatureNonRetenue(url, data, emailPreview, callback) {
        var $refusCommentaire   = $('#modal-confirm-candidature-non-retenue #refus_commentaire');
        var $modalConfirmRefuse = $('#modal-confirm-candidature-non-retenue');
        var csrf = candidatLocataireCRUD.getCsrf();

        data[csrf.name] = csrf.value;
        if (emailPreview) {
            $('#btn-candidature-non-retenue-preview-spinner').show();
        } else {
            $('#btn-candidature-non-retenue-confirm-spinner').show();
        }

        if(callback != undefined && callback.start) {
            callback.start();
        }

        $.ajax({
            type: 'POST',
            url: PROFIL + url,
            data: data,
            dataType: 'json',
        }).done(function(response) {
            if(callback != undefined && callback.stop) {
                callback.stop();
            }
            Util.getCsrf();
            if(!hasAjaxErrors(response, $modalConfirmRefuse)) {
                if (emailPreview) {
                    $("#previewHeaderFrom").html(response.from);
                    $("#previewHeaderTo").html(response.to);
                    $("#previewHeaderSubject").html(response.subject);
                    $("#emailCandidatureNonRetenuePreview").contents().find('body').html(response.content);
                    $('#previewHeader, #hidePreview').show();
                    $('#btn-candidature-non-retenue-preview-spinner').hide();
                } else {
                    $("#previewHeaderFrom").html('');
                    $("#previewHeaderTo").html('');
                    $("#previewHeaderSubject").html('');
                    $("#emailCandidatureNonRetenuePreview").contents().find('body').html('');
                    $('#previewHeader').hide();
                    $refusCommentaire.val('');
                    $('#btn-candidature-non-retenue-confirm-spinner').hide();

                    $modalConfirmRefuse.modal('hide');

                    $('tr[data-lp-uuid="' + lpUuid + '"]').find('div[id="dossier_statut_"]').html('Candidature non retenue');
                    var html = '<li><a href="admin/candidats/unarchive/' + contactId + '" class="dropdown-item unarchive_contact" data-id="' + contactId + '" title="Désarchiver le dossier"><i class="far fa-box-open fa-fw"></i>Désarchiver le dossier</a></li>';
                    $('tr[data-lp-uuid="' + lpUuid + '"]').find('.list-unstyled.dropdown-menu--candidat-actions').html(html);
                    $('tr[data-lp-uuid="' + lpUuid + '"]').addClass('active-archived');

                }
            }
        });
    }

    $('#btn-candidature-non-retenue-preview, #btn-candidature-non-retenue-confirm' ).off().on('click', function () {
        var data = {
            refus_commentaire: $refusCommentaire.val(),
            contactId: contactId
        };

        var url = null;
        if($refusCommentaire.val().trim()) {
            $('#btn-candidature-non-retenue-confirm').removeAttr('disabled');
            if($(this).attr('id') == 'btn-candidature-non-retenue-preview') {
                hidePreview = false;
                $('#btn-candidature-non-retenue-preview').hide();
                url = '/candidats/ajaxProjectRefusedEmailPreview';
                appelCandidatureNonRetenue(url, data, true);
            } else {
                url = '/candidats/ajaxProjectRefused';
                $modalConfirmRefuse.modal('hide');

                modalOuiNonV2('Confirmez-vous le refus de cette candidature ?<br><br>' +
                    'Un email sera alors envoyé automatiquement au candidat, et le dossier sera archivé.<br>',
                    'Attention', function (callback) {
                        appelCandidatureNonRetenue(url, data, false, callback);
                    }, function () {
                        $modalConfirmRefuse.modal('show');
                    });
            }
        } else {
            $('#btn-candidature-non-retenue-confirm').attr('disabled', 'disabled');
            hasAjaxErrors(
                { msg:
                        { errors:
                                { refus_commentaire: 'Motif requis'}
                        }
                }
                , $modalConfirmRefuse);
        }

    });

}

/**
 * Modal d'envoi de Commentaire au client
 *
 * @param e
 */
function openModalCommentaireClient(e)
{
    var btn       = $(e.currentTarget);
    var uuidContact = btn.data('con-uuid');
    var $modal     = $('#modal-commentaire-client');
    var form      = document.getElementById("form-commentaire-client");
    var $form      = $(form);

    form.reset();
    $form.find('input[name="idContact"]').val(uuidContact);

    $.ajax({
        type: 'GET',
        url: PROFIL + '/candidats/ajaxGetCandidat/' + uuidContact,
        dataType: 'json',
    }).done(function(response) {
        $modal.find('input[name="email"]').val(response.msg.email);
        $modal.modal();
        $form.off('submit').on('submit', function(e) {
            e.preventDefault();
            addSpinnerOnSubmitBtn('form-commentaire-client');
            var csrf = candidatLocataireCRUD.getCsrf();
            $.ajax({
                type: 'POST',
                url: $form.attr('action'),
                data: $form.serialize() + '&' + csrf.name + '=' + csrf.value,
                dataType: 'json',
            }).done(function(response) {
                $('input.csrf-protection').val(response.csrfTokenValue);
                if (response.success) {
                    $modal.modal('hide');
                    return;
                }
                displayErrorMessage(response.msg);
            }).fail(function() {
                Util.getCsrf();
                displayErrorMessage('Désolé, une erreur est survenue durant l\'envoi du message.<br>' +
                    'Nous faisons tout notre possible pour corriger le soucis au plus vite.');
            }).always(function() {
                removeSpinnerOnSubmitBtn('form-commentaire-client');
            });
        });
    });
}

/**
 * Modal d'envoi de Commentaire au client
 *
 * @param e
 */
function openModalExecuteKyc(e)
{
    var btn    = $(e.currentTarget);
    var $modal = $('#modal-execution-kyc');
    var divError = $modal.find('.div-danger');
    var divContent = $modal.find('.div-content');

    e.preventDefault();
    divContent.html('<span class="spinner-border spinner-border" role="status" aria-hidden="true"></span> Récupération des informations en cours ... merci de patienter');
    divError.addClass('d-none');
    $modal.modal('show');

    $.ajax({
        type: 'GET',
        url: '/api/project/foldersHasKyc/' + btn.data('lp-uuid'),
        dataType: 'json',
    }).done(function(response) {
        if (response.msg.enabled == false) {
            divContent.html('L\'option de vérification de pièce n\'est pas active sur votre agence. Merci de bien vouloir vous rapprocher de votre service commercial');
        } else {
            var toUpdate = false;
            response.msg.folders.forEach(function(folder) {
                if (folder.kyc.hasControl == false) {
                    toUpdate = true;
                }
            });

            $('#modalKycOwner').html('');
            if (response.msg.owner) {
                $('#modalKycOwner').html(response.msg.owner.firstname + ' ' + response.msg.owner.lastname);
            }

            if (toUpdate) {
                divContent.html('Je souhaite lancer le contrôle automatique de ce dossier <button onclick="startControl(\'' + btn.data('lp-uuid') + '\');" class="btn btn-submit">Démarrer</button>');
            } else {
                retrieveControl(btn.data('lp-uuid'));
            }
        }

        divError.addClass('d-none');
        divContent.removeClass('d-none');
    }).fail(function(data) {
        divError.html('Une erreur est survenue. Merci de bien vouloir essayer ultérieurement.');
        divError.removeClass('d-none');
        divContent.addClass('d-none');
    });

    return false;
}

/**
 * Modal d'envoi de Commentaire au client
 *
 * @param e
 */
function openModalProjectBail(e)
{
    var $modal = $('#modal-project-bail');
    var divError = $modal.find('.div-danger');

    var depotType = $(e.currentTarget).data('depotType');
    var depotUuid = $(e.currentTarget).data('depotUuid');
    var depotName = $(e.currentTarget).data('depotName');

    e.preventDefault();
    if (depotType !== 'zelok') {
        alert('Fonctionnalité non disponible pour ce type de dossiers');
        return false;
    }

    divError.addClass('d-none');
    $modal.modal('show');

    initProjetBail(depotType, depotUuid, depotName);

    return false;
}

function extendFolder(projectUuid) {
    var $row = $('#table-candidats-locataires').find('tr[data-lp-uuid="'+ projectUuid + '"]');
    if ($row.html().search('cacher') == -1) {
        $row.trigger('click');
    }
    $row[0].scrollIntoView(true);
    var $modal = $('#modal-execution-kyc');
    $modal.modal('hide');
}

function startControl(lpUuid) {
    var $modal = $('#modal-execution-kyc');
    var divError = $modal.find('.div-danger');
    var divContent = $modal.find('.div-content');
    divContent.html('<span class="spinner-border spinner-border" role="status" aria-hidden="true"></span> Récupération des informations en cours ... merci de patienter');

    divError.addClass('d-none');

    $.ajax({
        type: 'GET',
        url: '/api/project/executeKyc/' + lpUuid,
        dataType: 'json',
    }).done(function(response) {
        if (response.msg.enabled == false) {
            divContent.html('L\'option de vérification de pièce n\'est pas active sur votre agence. Merci de bien vouloir vous rapprocher de votre service commercial');
            divError.addClass('d-none');
            divContent.removeClass('d-none');
        } else {
            retrieveControl(lpUuid);
        }
    }).fail(function(data) {
        divError.html('Une erreur est survenue. Merci de bien vouloir essayer ultérieurement.')
        divError.removeClass('d-none');
        divContent.addClass('d-none');
    });

    return false;
}

function retrieveControl(lpUuid) {
    var $modal = $('#modal-execution-kyc');
    var divError = $modal.find('.div-danger');
    var divContent = $modal.find('.div-content');
    divContent.html('<span class="spinner-border spinner-border" role="status" aria-hidden="true"></span> Récupération des informations en cours ... merci de patienter');

    divError.addClass('d-none');

    $.ajax({
        type: 'GET',
        url: '/api/project/retrieveKyc/' + lpUuid,
        dataType: 'json',
    }).done(function(response) {
        if (response.msg.enabled == false) {
            divContent.html('L\'option de vérification de pièce n\'est pas active sur votre agence. Merci de bien vouloir vous rapprocher de votre service commercial');
        } else if (response.msg.complete == false) {
            divContent.html('<span class="spinner-border spinner-border" role="status" aria-hidden="true"></span> Les documents sont en cours d\'analyse. Ceci peut durer plusieurs minutes.');
        } else if (response.msg.complete == true) {
            divContent.html('Les documents ont été analysés. Nous vous invitons à afficher les documents relatifs aux candidats en cliquant\n\
                <a class="btn btn-submit" onclick="extendFolder(\'' + lpUuid + '\')">ici</a>');
        }
        divError.addClass('d-none');
        divContent.removeClass('d-none');
    }).fail(function(data) {
        divError.html('Une erreur est survenue. Merci de bien vouloir essayer ultérieurement.')
        divError.removeClass('d-none');
        divContent.addClass('d-none');
    });

    return false;
}

/**
 * Modal de signature du bail
 *
 * @param e
 */
function openModalSignatureBail(e)
{
    var btn       = $(e.currentTarget);
    var idContact = btn.data('id');
    var $modal    = $('#modal-signature-bail');
    var form      = document.getElementById('form-signature-bail');
    var $form     = $(form);

    form.reset();
    $form.find('input[name="idContact"]').val(idContact);

    $modal.modal();
    $form.off('submit').on('submit', function(e) {
        e.preventDefault();
        addSpinnerOnSubmitBtn('form-signature-bail');
        var csrf = candidatLocataireCRUD.getCsrf();
        $.ajax({
            type: 'POST',
            url: $form.attr('action'),
            data: $form.serialize() + '&' + csrf.name + '=' + csrf.value,
            dataType: 'json',
        }).done(function(response) {
            $('input.csrf-protection').val(response.csrfTokenValue);
            if (response.success) {
                candidatLocataireCRUD.refresh();
                $modal.modal('hide');
                return;
            }
            displayErrorMessage(response.msg);
        }).always(function() {
            removeSpinnerOnSubmitBtn('form-signature-bail');
        });
    });
}


function checkHasEmailSolva() {
    if (! HAS_EMAIL_SOLVA) {
        displayErrorMessage('Pour permettre le transfert de vos dossiers candidats locataires, veuillez renseigner un utilisateur actif "Gestionnaire Solva" sur votre page "Mon équipe"');
        return false;
    }
    return true
}


function openModalTransfertSolva(e, gliZelok) {

    var modalId = "#modal-transfert-solva";
    if(!checkHasEmailSolva()) {
        return;
    }

    var modal = $(modalId);
    var modalBody  = $(modalId+" .modal-body");
    var modalTitle = $(modalId+" .modal-title");
    if(gliZelok) {
        modalTitle.html('Transfert Solva<i class="color-primary"> GLI ZELOK</i>');
    } else {
        modalTitle.html('Transfert <i class="color-primary">Solva</i>');
    }

    var btn = $(e.currentTarget);
    var gli = btn.data('gli');
    var uuid =  btn.data('lp-uuid');
    var idContact = btn.data('id');
    var csrf = candidatLocataireCRUD.getCsrf();
    var data = { idContact: idContact, uuid: uuid, gli: gli };
    data[csrf.name] = csrf.value;

    $.ajax({
        type: 'POST',
        url: 'api/candidats_locataires/transfert_solva/ajaxGetFormGliZelok',
        data: data,
        dataType: 'json',
    }).done(function(response) {
        $('input.csrf-protection').val(response.msg.csrfTokenValue);
        modalBody.html(response.msg.form);
        modal.modal();
        eval(response.msg.js);
    });
}

function openModalTransfertSolvaGliZelok(e) {
    return openModalTransfertSolva(e, true);
}

function openModalTransfertSolvaClassic(e) {
    return openModalTransfertSolva(e, false);
}


/**
 * OBSOLETE
 * @param e
 */
function openModalTransfertSolvaOld(e)
{
    if(!checkHasEmailSolva()) {
        return;
    }

    var btn = $(e.currentTarget);
    var uuid =  btn.data('lp-uuid')
    var idContact = btn.data('id');
    var form = document.getElementById("form-transfert-solva");

    $.ajax({
        type: 'GET',
        url: 'api/candidats_locataires/transfert_solva/ajaxGetDatasForTransfertSolva/' + idContact,
        dataType: 'json',
    }).done(function(response) {
        var data = response.msg;

        form.reset();
        $('#form-transfertSolva-idContact').val(idContact);
        $('#form-transfertSolva-uuid').val(uuid);
        $('#detailsLocataire').val(data.resumeLocataire);
        $('#ts-adresse-logement').val(data.adresseLogement);
        $('#ts-montantLoyer').val(data.loyer);
        $('#ts-charge').val(data.charge);
        $('#modal-ts-surface-habitable').val(data.surfaceHabitable);
        $('#form-ts-nom-agence').val(data.agence);
        $('#form-ts-nom-conseiller').val(data.conseiller);
        $('#radio-gli-garant').prop("checked", data.garant);
        $('#ts-date-entree').datepicker('setDate', data.dateEntree);

        $('#modal-transfert-solva').modal();

        $('.datepicker').datepicker({
            language: 'fr'
        });
        $('#form-transfert-solva').off('submit').on('submit', function(e) {
            e.preventDefault();
            var $form = $(this);
            addSpinnerOnSubmitBtn('form-transfert-solva');
            var csrf = candidatLocataireCRUD.getCsrf();
            $.ajax({
                type: 'POST',
                url: $form.attr('action'),
                data: $form.serialize() + '&' + csrf.name + '=' + csrf.value,
                dataType: 'json',
            }).done(function(response) {
                $('input.csrf-protection').val(response.csrfTokenValue);
                if (response.success) {
                    candidatLocataireCRUD.refresh();
                    $('#modal-transfert-solva').modal('hide');
                } else {
                    displayErrorMessage(response.msg);
                }
            }).always(function() {
                removeSpinnerOnSubmitBtn('form-transfert-solva');
            });
        });
    });
}

/**
 * Personnalisation des lignes
 * @param {array} row
 * @param {int}   index
 * @returns {{classes: string}|{}}
 */
function tableauCandidatLocataireRowStyle(row, index) {
    var classZelok = row.idLocationProject ? 'dossier-zelok ' : '';
    var classArchived = (row.loc_isArchived && row.loc_isArchived == '1') ? 'active-archived ' : '';

    switch (row.loc_statut) {
        case 'transfere_solva':
            return {
                classes: classZelok + classArchived + 'active-transfert'
            };
        case 'bail_signe':
            return {
                classes: classZelok + classArchived + 'active-signe'
            };
        default:
            return {
                classes: classZelok + classArchived
            };
    }
}


var candidatLocataireCRUD = {

    PASTILLES: {
        DOC_COMMENTE: '<img src="assets/img/clust/pastilles/rouge.svg" alt="Document rejeté" title="Document rejeté" width="12">',
        DOC_VALIDE: '<img src="assets/img/clust/pastilles/vert.svg" alt="Document validé" title="Document validé" width="12">',
    },

    getCsrf: function() {
        var $csrfInput = $('input.csrf-protection');
        return {
            name: $csrfInput.attr('name'),
            value: $csrfInput.val(),
        };
    },

    actions: {

        /********************************************************   GLI ZELOK ***************************/

        /**
         * SOLVA GLI
         * VALIDER
         * @param evt
         */
        solvaGliValiderDossier: function(e) {
            e.preventDefault();
            var $button = $(e.currentTarget);

            var modal = $("#modal-valider-solva-gli-zelok");
            var modalContent = $("#modal-valider-solva-gli-zelok .modal-content");
            var btn = $(e.currentTarget);
            var uuid =  btn.data('lp-uuid');
            var contactName = btn.data('contactname');
            var csrf = candidatLocataireCRUD.getCsrf();

            var data = { contactName: contactName, uuid: uuid, embedded: 1, version:1 };
            data[csrf.name] = csrf.value;

            $.ajax({
                type: 'POST',
                url: 'api/projets/solva/forms/ajaxGetValiderFormGliZelok',
                data: data,
                dataType: 'json',
            }).done(function(response) {
                $('input.csrf-protection').val(response.msg.csrfTokenValue);
                modalContent.html(response.msg.form);
                modal.modal();
            });
        },

        /**
         * SOLVA GLI
         * ANNULER
         * @param evt
         */
        solvaGliAnnulerDossier: function(e) {
            e.preventDefault();
            var $button = $(e.currentTarget);

            var modal = $("#modal-annuler-solva-gli-zelok");
            var modalContent = $("#modal-annuler-solva-gli-zelok .modal-content");
            var btn = $(e.currentTarget);
            var uuid =  btn.data('lp-uuid');
            var contactName = btn.data('contactname');
            var csrf = candidatLocataireCRUD.getCsrf();

            var data = { contactName: contactName, uuid: uuid, embedded: 1, version:1 };
            data[csrf.name] = csrf.value;


            $.ajax({
                type: 'POST',
                url: 'api/projets/solva/forms/ajaxGetAnnulerFormGliZelok',
                data: data,
                dataType: 'json',
            }).done(function(response) {
                $('input.csrf-protection').val(response.msg.csrfTokenValue);
                modalContent.html(response.msg.form);
                modal.modal();
            });
        },
        /**
         * SOLVA GLI
         * REFUS
         * @param evt
         */
        solvaGliRefuserDossier: function(e) {
            e.preventDefault();
            var modal = $("#modal-refuser-solva-gli-zelok");
            var modalContent = $("#modal-refuser-solva-gli-zelok .modal-content");
            var btn = $(e.currentTarget);
            var uuid =  btn.data('lp-uuid');
            var contactName = btn.data('contactname');
            var upid = btn.data('upid');
            var csrf = candidatLocataireCRUD.getCsrf();
            var data = { contactName: contactName, uuid: uuid, upid: upid, embedded: 1, version:1 };
            data[csrf.name] = csrf.value;

            $.ajax({
                type: 'POST',
                url: 'api/projets/solva/forms/ajaxGetRefuserFormGliZelok',
                data: data,
                dataType: 'json',
            }).done(function(response) {
                $('input.csrf-protection').val(response.msg.csrfTokenValue);
                modalContent.html(response.msg.form);
                modal.modal();
            });
        },


        /**
         * Valider le dossier
         * @param e
         */
        approveAllDocuments: function(e) {
            var $currentTarget = $(e.currentTarget);
            var $mainTr = $($currentTarget.parents('tr').first());

            var csrf = candidatLocataireCRUD.getCsrf();
            var data = { conUuid: null, lpUuid: $mainTr.data('lp-uuid') };
            if ($currentTarget.data('conuuid')) {
                data.conUuid = $currentTarget.data('conuuid');
            }
            data[csrf.name] = csrf.value;
            $.post(PROFIL + '/candidats/ajaxGetMissingDocuments', data, function(response) {
                $('input.csrf-protection').val(response.csrfTokenValue);
                var html = '<div class="missingDocs">Voulez-vous approuver toutes les pièces du candidat locataire ?<br/><br/>';
                var n = 0;
                if(Object.keys(response.msg).length) {
                    html+='<span class="red-text">Attention, certains documents sont manquants</span><br/><table><tr>';
                    $.each(response.msg, function(user, docs) {
                        n++;
                        html += '<th>'+user+'</th>';
                    });
                    html += '</tr><tr>';
                    $.each(response.msg, function(user, docs) {
                        html += '<td class="leftborder"><ul style="padding: 0">';
                        $.each(docs, function(k, doc) {
                            html += '<li >' + doc + '</li>';
                        });
                        html += '</ul></td>';
                    });
                    html += '</tr><tr><td colspan="'+n+'" ><a  href="/admin/location_project/resume/'+$mainTr.data('lp-uuid')+'" target="_blank">Voir la synthèse de tous les documents du projet</a></td></tr></table></div>';
                }
                modalOuiNon(
                    html,
                    'Approuver toutes les pièces ?',
                    function() {
                        csrf = candidatLocataireCRUD.getCsrf();
                        data[csrf.name] = csrf.value;
                        $.post(PROFIL + '/candidats/ajaxApproveAllProject', data, function(response) {
                            $('input.csrf-protection').val(response.csrfTokenValue);
                            candidatLocataireCRUD.refresh();
                        }, 'json').fail(function(data) {
                            Util.getCsrf();
                            displayErrorMessage(data.responseText);
                        });
                    }
                );

                candidatLocataireCRUD.refresh();
            }, 'json').fail(function(data) {
                Util.getCsrf();
                displayErrorMessage(data.responseText);
            });


        },

        approveDoc: function(e) {
            var btn = $(e.currentTarget);
            if (confirm(btn.attr('title'))) {
                var url, idDossier, data, typeDossier;
                var csrf = candidatLocataireCRUD.getCsrf();

                if (btn.data('doc-uuid')) {
                    typeDossier = 'zelok';
                    idDossier = btn.data('doc-uuid');
                    url = PROFIL + '/candidats/approveDocZelok/' + idDossier;
                    data = {};
                } else {
                    typeDossier = 'clust';
                    idDossier = btn.data('dossier-id');
                    url = PROFIL + '/candidats/approveDoc';
                    data = {
                        idDoc: btn.data('docid'),
                        idDossier: idDossier
                    };
                }
                data[csrf.name] = csrf.value;

                $.post(url, data, function(data) {
                    if (typeDossier === 'zelok') {
                        $('tr[data-doc-uuid="' + idDossier + '"] td.doc-line-pastille').html(candidatLocataireCRUD.PASTILLES.DOC_VALIDE);
                    } else {
                        $('.doc_line').remove();
                        $('#tr_' + idDossier).after(data).addClass('active');
                    }
                }).always(function(data) {
                    Util.getCsrf();
                });
            }
        },

        /**
         * Modal d'envoi de Commentaire au client
         *
         * @param e
         */
        openModalAffectationClient: function(e) {
            var $btn      = $(e.currentTarget);
            var $tr       = $btn.parents('tr');
            var uuid      = $btn.data('conuuid');
            var $modal    = $('#modal-affectation-client');
            var form      = document.getElementById("form-affectation-client");
            var $form     = $(form);
            var $selectAgenceLocataire =  $('#agences-locataire');
            var $selectConseiller = $modal.find('select[name="conseiller"]');

            form.reset();
            $selectAgenceLocataire
                .select2({
                    allowClear: true,
                    width: '100%'
                })
                .val($tr.data('agence-uuid')).trigger('change');

            $.ajax({
                type: 'GET',
                url: '/api/proprietaires/index?filters={"userCandidat":"' + uuid + '"}',
                dataType: 'json',
            }).done(function(response) {
                var select = $modal.find('select[name="proprietaire"]');
                select.empty();
                if (response.total > 0) {
                    select.html('<option value="' + response.rows[0].uuid + '" selected>' +
                        [response.rows[0].lastName, response.rows[0].firstName].join(' ') + ' - ' + response.rows[0].email +
                        '</option>');
                }
            });

            $.ajax({
                type: 'GET',
                url: PROFIL + '/candidats/ajaxGetListAgent/' + uuid,
                dataType: 'json',
            }).done(function(response) {
                $modal.find('input[name="uuid"]').val(response.msg.uuid);
                $modal.find('input[name="email"]').val(response.msg.email);

                $selectConseiller.empty();
                for (var i = 0; i < response.msg.agents.length; i++) {
                    var uuid = response.msg.agents[i].con_uuid;
                    var text = [response.msg.agents[i].Nom, response.msg.agents[i].Prenom].join(' ');
                    var selected = '';
                    if ((i == 0 && response.msg.current.uuid == '') || response.msg.current.con_uuid == uuid) {
                        selected = 'selected="selected"';
                    }
                    $selectConseiller.append('<option value="' + uuid + '" ' + selected + '>' + text + '</option>');
                }

                $modal.modal();
                $(form).off('submit').on('submit', function(e) {
                    e.preventDefault();
                    addSpinnerOnSubmitBtn('form-affectation-client');
                    var csrf = candidatLocataireCRUD.getCsrf();
                    $.ajax({
                        type: 'POST',
                        url: $form.attr('action'),
                        data: $form.serialize() + '&' + csrf.name + '=' + csrf.value,
                        dataType: 'json',
                    }).done(function(response) {
                        $('input.csrf-protection').val(response.csrfTokenValue);
                        if (response.success) {
                            $modal.modal('hide');
                            candidatLocataireCRUD.refresh();
                            return;
                        }
                        displayErrorMessage(response.msg);
                    }).fail(function() {
                        Util.getCsrf();
                        displayErrorMessage('Désolé, une erreur est survenue durant l\'envoi du message.<br>' +
                            'Nous faisons tout notre possible pour corriger le soucis au plus vite.');
                    }).always(function() {
                        removeSpinnerOnSubmitBtn('form-affectation-client');
                    });
                });
            });

            $selectAgenceLocataire.on('change', function() {
                var $this = $(this);
                $selectConseiller.empty();
                if ($this.val()) {
                    $.ajax({
                        type: 'GET',
                        url: '/admin/candidats/ajaxGetAgentsImmobilier/' + $this.val(),
                        dataType: 'json',
                    }).done(function (response) {
                        response.data.forEach(function (agent) {
                            var text = [agent.nom, agent.prenom].join(' ');
                            $selectConseiller.append('<option value="' + agent.uuid + '">' + text + '</option>');
                        });
                    });
                }
            });

            $modal.on('hidden.bs.modal', function(e) {
                $selectAgenceLocataire.off();
                if ($selectAgenceLocataire.hasClass('select2-hidden-accessible')) {
                    $selectAgenceLocataire.select2('destroy');
                }
            });
        },

        openModalCommentDoc: function(e) {
            var btn = $(e.currentTarget);
            var idUpload = btn.data('uploadid');
            var csrf;

            $.when(Util.getCsrf()).then(function(data) {
                csrf = data;
            });

            $('#modal-comment-doc #mcd-note').val('');
            $('#modal-comment-doc').modal();
            $('#modal-comment-doc .btn-validate-note').off('click').on('click', function () {
                var note = $('#mcd-note').val();
                var libellePiece = btn.data('libelle-piece');
                var dossierId    = btn.data('dossier-id');
                var idDoc, typeDossier;

                if (btn.data('doc-uuid')) {
                    typeDossier = 'zelok';
                    idDoc = btn.data('doc-uuid');
                } else {
                    typeDossier = 'clust';
                    idDoc = btn.data('docid');
                }

                var data = {
                    typeDossier: typeDossier,
                    idDoc: idDoc,
                    idUpload: idUpload,
                    note: note,
                    libellePiece: libellePiece,
                    idDossier: dossierId,
                };
                data[csrf.name] = csrf.token;
                $.post(PROFIL + '/candidats/commentDoc', data, function(response) {
                    $('#modal-comment-doc').modal('hide');
                    if (typeDossier === 'zelok') {
                        $('tr[data-doc-uuid="' + idDoc + '"] td.doc-line-pastille').html(candidatLocataireCRUD.PASTILLES.DOC_COMMENTE);
                        $('tr[data-doc-uuid="' + idDoc + '"] td.doc-line-comment').first().html(
                            '<div class="text-danger"><small><i class="far fa-comment-times"></i> ' + data.note + '</small></div>');
                    } else {
                        $('.doc_line').remove();
                        var mainTr = $('#tr_' + dossierId);
                        mainTr.after(response);
                        mainTr.addClass('active');
                    }
                });
            });
        },

        solvaDemanderComplements: function(evt) {
            var $this = $(this);
            // var lpUuid = $this.parents('tr').prev('tr.dossier-zelok').data('lp-uuid');
            // var upid = $this.data('upid') ? $this.data('upid') : null;
            var conUuid = $this.attr('data-con-uuid');
            Util.modalPrompt('Information(s) complémentaire(s) souhaitée(s) :', '',
                'Demande d\'informations complémentaires', function(value) {
                    $.ajax({
                        method: 'POST',
                        url: 'api/projets/solva/demander_complements',
                        dataType: 'json',
                        data: {
                            // lpUuid: lpUuid,
                            // upid: upid,
                            conUuid: conUuid,
                            comment: value,
                        }
                    }).done(function(response) {
                        if (response.success) {
                            candidatLocataireCRUD.refresh();
                        } else {
                            displayErrorMessage(response.msg);
                        }
                    }).fail(function() {
                        displayErrorMessage('Désolé, une erreur est survenue.<br>Veuillez contacter le support si le problème persiste.');
                    });
                });
        },

        solvaRefuserDossier: function(evt) {
            evt.preventDefault();
            var $button     = $(evt.currentTarget);
            var lpuuid      = $button.data('lp-uuid');
            var upid      = $button.data('upid');
            var contactName = $button.data('contactname');

            // uncheck radio buttons
            $("#modal-solva-refuse input[name='notifyAgency']:checked").prop('checked', false);
            // reinit motif
            $('#modal-solva-refuse .form-control.motif').val('');
            // uncheck confirm
            $('#modal-solva-refuse .form-check-input.confirm').prop('checked', false);


            $('#modal-solva-refuse').find('.color-tenant.tenant-fullname').html(contactName);
            $('#modal-solva-refuse').modal();

            $('#modal-solva-refuse .btn-refuse-solva').on('click', function(e) {
                e.stopImmediatePropagation();

                var notifyAgent = $("#modal-solva-refuse input[name='notifyAgency']:checked").val();
                var motif = $('#modal-solva-refuse .form-control.motif').val().trim();
                if(!$('#modal-solva-refuse .form-check-input.confirm').is(':checked')) {
                    displayErrorMessage('Veuillez au préalable cocher <strong>Etes-vous sûr de vouloir refuser ce dossier</strong>');
                } else if(motif.length<=0) {
                    displayErrorMessage('Veuillez renseigner le <strong>motif</strong>');
                    $('#modal-solva-refuse .form-label.refuseMotif').addClass('red-text');
                    setTimeout(function () {
                        $('#modal-solva-refuse .form-label.refuseMotif').removeClass('red-text');
                    }, 3000);
                } else if(!notifyAgent) {
                    displayErrorMessage('Veuillez renseigner <strong>Notifier l\'agence</strong>');
                    $('#modal-solva-refuse .notify-title').addClass('red-text');
                    setTimeout(function () {
                        $('#modal-solva-refuse .notify-title').removeClass('red-text');
                    }, 3000);
                } else {
                    var url = 'api/projets/solva/refuser';
                    var csrf = candidatLocataireCRUD.getCsrf();

                    var data = {
                        notifyAgent: notifyAgent,
                        lpUuid: lpuuid,
                        upid: upid,
                        comment: motif,
                    };

                    data[csrf.name] = csrf.value;
                    $.ajax({
                        type: 'POST',
                        url: url,
                        data: data,
                        dataType: 'json'
                    }).done(function (response) {
                        $('input.csrf-protection').val(response.csrfTokenValue);
                        if (response.success) {
                            $('#modal-solva-refuse').modal('hide');
                            candidatLocataireCRUD.refresh();
                        } else {
                            displayErrorMessage(response.msg);
                        }


                    }).fail(function() {
                        displayErrorMessage('Désolé, une erreur est survenue.<br>Veuillez contacter le support si le problème persiste.');
                    });
                }
            });
        },


        solvaValidDossier: function(evt) {
            evt.preventDefault();
            var $button     = $(evt.currentTarget);
            var lpuuid      = $button.data('lp-uuid');
            var contactName = $button.data('contactname');

            // uncheck radio buttons
            $("#modal-solva-validate input[name='notifyAgency']:checked").prop('checked', false);
            // uncheck confirm
            $('#modal-solva-validate .form-check-input.confirm').prop('checked', false);

            $('#modal-solva-validate').find('.color-tenant.tenant-fullname').html(contactName);
            $('#modal-solva-validate').modal();

            $('#modal-solva-validate .btn-validate-solva').on('click', function(e) {
                e.stopImmediatePropagation();

                var notifyAgent = $("#modal-solva-validate input[name='notifyAgency']:checked").val();
                if(!$('#modal-solva-validate .form-check-input.confirm').is(':checked')) {
                    displayErrorMessage('Veuillez au préalable cocher <strong>Etes-vous sûr de vouloir valider ce dossier</strong>');
                } else if(!notifyAgent) {
                    displayErrorMessage('Veuillez renseigner <strong>Notifier l\'agence</strong>');
                    $('#modal-solva-validate .notify-title').addClass('red-text');
                    setTimeout( function() {
                        $('#modal-solva-validate .notify-title').removeClass('red-text');
                    } , 3000);
                } else {
                    var url = '/api/projets/solva/validate/'+lpuuid;
                    var csrf = candidatLocataireCRUD.getCsrf();
                    var data = {
                        notifyAgent: notifyAgent,
                    };

                    data[csrf.name] = csrf.value;
                    $.ajax({
                        type: 'POST',
                        url: url,
                        data: data,
                        dataType: 'json'
                    }).done(function (response) {
                        $('#modal-solva-validate').modal('hide');
                        candidatLocataireCRUD.refresh();
                    });
                }
            });
        },
    },

    modalOuiNonBailEnProduction: function(evt) {
        evt.preventDefault();
        var data = {
            idContact: parseInt($(this).data('con-id')),
        };
        modalOuiNon('Êtes vous sur de vouloir continuer ?', 'Bail en production', function() {
            $.ajax({
                type: 'POST',
                url: PROFIL + '/candidats/ajaxSetBailEnProduction',
                data: data,
                dataType: 'json',
            }).done(function(response) {
                if (response.success) {
                    candidatLocataireCRUD.refresh();
                } else {
                    displayErrorMessage(response.msg);
                }
            });
        });
    },

    deleteCandidat: function(evt) {
        evt.preventDefault();
        var url = $(this).attr('href');
        modalOuiNon('Êtes vous sur de vouloir supprimer ce compte ?', 'Attention', function() {
            document.location.href = url;
        });
    },


    init: function() {
        $('.table_clust').off()
            .on('click', 'td.colPriorite', zelok.pages.candidatsLocataires.editPriority)
            .on('click', '.btn-init-location-project', candidatLocataireCRUD.startNewLocationProject)
            .on('click', 'tr.dossier-zelok', candidatLocataireCRUD.displayFolder)
            .on('click', '.voir_liste_clust', candidatLocataireCRUD.voirListeClust)
            .on('click', '.voir_liste_zelok', candidatLocataireCRUD.voirListeZelok)
            .on('click', '.btn-bail-en-production', candidatLocataireCRUD.modalOuiNonBailEnProduction)
            .on('click', '.btn-sign-bail', openModalSignatureBail)
            .on('click', '.approve_doc', candidatLocataireCRUD.actions.approveDoc)
            .on('click', '.comment_doc', candidatLocataireCRUD.actions.openModalCommentDoc)
            .on('click', 'button.approve_all', candidatLocataireCRUD.actions.approveAllDocuments)
            .on('click', '.btn-refuser-demarche', openModalRefuseProc)
            .on('click', '.btn-add-private-note', openModalAddPrivateNote)
            .on('click', '.btn-candidature-non-retenue', openModalCandidatureNonRetenue)
            .on('click', '.delete_contact', candidatLocataireCRUD.deleteCandidat)
            .on('click', '.enable_contact', enableCandidat )
            .on('click', '.disable_contact', disableCandidat )
            .on('click', '.archive_contact', archiveCandidat )
            .on('click', '.unarchive_contact', unarchiveCandidat )
            .on('click', '.transfert-solva', openModalTransfertSolvaClassic)
            .on('click', '.transfert-solva-gli-zelok', openModalTransfertSolvaGliZelok)
            .on('click', '.btn-solva-refuser-dossier', candidatLocataireCRUD.actions.solvaGliRefuserDossier)
            .on('click', '.btn-solva-valider-dossier', candidatLocataireCRUD.actions.solvaGliValiderDossier)
            .on('click', '.btn-solva-gli-refuser-dossier', candidatLocataireCRUD.actions.solvaGliRefuserDossier)
            .on('click', '.btn-solva-gli-valider-dossier', candidatLocataireCRUD.actions.solvaGliValiderDossier)
            .on('click', '.btn-solva-gli-annuler-dossier', candidatLocataireCRUD.actions.solvaGliAnnulerDossier)
            .on('click', '.btn-solva-demander-complements', candidatLocataireCRUD.actions.solvaDemanderComplements)
            .on('click', '.btn-commentaire-client', openModalCommentaireClient)
            .on('click', '.btn-affectation-client', candidatLocataireCRUD.actions.openModalAffectationClient)
            .on('click', '.btn-execute-kyc', openModalExecuteKyc)
            .on('click', '.btn-project-bail', openModalProjectBail)
            .on('load-success.bs.table', candidatLocataireCRUD.autoScrollToLocationProject)
        ;
    },

    refresh: function() {
        $('#table-candidats-locataires').bootstrapTable('refresh', {silent: true});
    },

    displayFolder: function(e) {
        var $this = $(this);
        var btnVoirMembresDossiersZelok = $this.find('.btn-voir-membres-dossiers-zelok');
        var $img = $this.find('img.img-dossier-zelok');

        if ($this.hasClass('active')) {
            //$this.find('button.privateNote').addClass('color-tenant').removeClass('white-text');
            $('tr.doc_line').remove();
            $('tr.candidat-location-project').remove();
            btnVoirMembresDossiersZelok.html(btnVoirMembresDossiersZelok.html().replace('cacher', 'voir'));
            $img.attr('src', '/assets/img/picto-zelok-fond-bleu.png');
        } else {
            //$this.find('button.privateNote').removeClass('color-tenant').addClass('white-text');
            btnVoirMembresDossiersZelok.html(btnVoirMembresDossiersZelok.html().replace('voir', 'cacher'));
            var lpUuid = $this.data('lp-uuid');
            $.ajax({
                type: 'GET',
                url: window.location.href + '/ajaxGetCandidatsLocationProject/' + lpUuid,
                dataType: 'json',
            }).done(function(response) {
                var html = '';

                var colspanNomPrenom = location.pathname.startsWith('/admin/') ? 4 : 3;
                var offset = (true == $('#table-candidats-locataires .typeDossier').data('visible'))?0:1;
                colspanNomPrenom -= offset;
                var colspanProfilLibelle = (true == $('#table-candidats-locataires .colPriorite').data('visible'))?2:1;
                response.members.forEach(function(data) {
                    var colDocument = candidatLocataireCRUD.colDocumentsFormatter(true, {
                        con_uuid: data.con_uuid,
                        hasDocumentUploaded: data.statut.taux_fourni > 0,
                        typeDossier: 'zelok',
                        idFolder: data.idFolder,
                        foUuid: data.fo_uuid,
                        nbDocuments: data.nbDocuments,
                        canDownloadZip: data.canDownloadZip,
                        controls: data.controls,
                    });
                    var colActions = candidatLocataireCRUD.colActionsFormatter(true, {
                        id: data.idContact,
                        typeDossier: 'zelok',
                        foUuid: data.fo_uuid,
                        con_uuid: data.con_uuid,
                        canBeAssigned: data.canBeAssigned,
                        canExecuteKyc: data.canExecuteKyc,
                        status: data.statut.libelle,
                        userCanUploadDocs: true,
                        loc_nbRelances: 0,
                        loc_isArchived: data.loc_isArchived,
                    });
                    var textGarant = (data.Garant) ? '<br><span class="text-muted font-italic"><small>Garant : ' + data.Garant + '</small></span>' : '';
                    var folderMessage = '';
                    if (data.nbDocuments > 0) {
                        if (data.clp_type === 'locataire_en_couple') {
                            folderMessage = '<div class="text-muted font-italic"><small><i class="fal fa-info-circle"></i> Dossier locataire / conjoint déposé ensemble</small></div>';
                        } else if (data.clp_type === 'garant') {
                            folderMessage = '<div class="text-muted font-italic"><small><i class="fal fa-info-circle"></i> Dossier garant déposé séparément</small></div>';
                        } else if (data.clp_type === 'colocataire') {
                            folderMessage = '<div class="text-muted font-italic"><small><i class="fal fa-info-circle"></i> Dossier colocataire déposé séparément</small></div>';
                        } else if (data.clp_type === 'en_couple') {
                            folderMessage = '<div class="text-muted font-italic"><small><i class="fal fa-info-circle"></i> Dossier conjoint déposé séparément</small></div>';
                        } else {
                            folderMessage = '<div class="text-muted font-italic"><small><i class="fal fa-info-circle"></i> Dossier locataire déposé séparément</small></div>';
                        }
                    }

                    html +=
                        '<tr class="candidat-location-project"  id="tr-zelok-' + data.fo_uuid + '" ' +
                        'data-agence-uuid="' + data.ag_uuid + '" ' +
                        'data-lp-uuid="'+lpUuid+ '">' +
                        '<td colspan="'+ colspanProfilLibelle +'">' + data.profilLibelle + '</td>' +
                        '<td colspan="' + colspanNomPrenom + '">' +
                        data.Nom + ' ' + data.Prenom + '<br>' + data.Email + textGarant + folderMessage +
                        '</td>' +
                        '<td>' + candidatLocataireCRUD.colDatesFormatter(null, data) + '</td>' +
                        '<td>' + (data.actif ? 'oui' : 'non') + '</td>' +
                        '<td>' + colDocument + '</td>' +
                        '<td class="text-center">' + candidatLocataireCRUD.colStatusFormatter(data) + '</td>' +
                        '<td>' + colActions + '</td>' +
                        '</tr>';
                });
                $this.after(html);
                $('.candidat-location-project').slice(-1)[0].style.borderBottom =  '3px solid';
                $img.attr('src', '/assets/img/picto-zelok-fond-blanc.png');
            });
        }
        $this.toggleClass('active');
    },

    voirListeClust: function(e) {
        var btn = $(e.currentTarget);
        var idDossier = btn.data('dossierid');
        var mainTr = $('#tr_' + idDossier);
        if (mainTr.hasClass('active')) {
            $('tr.doc_line_' + idDossier).remove();

            btn.html(btn.html().replace('cacher les pièces', 'voir les pièces'));
        }
        else {
            $('tr.doc_line').remove();
            var data = {
                idDossier: idDossier,
            };
            $.post(PROFIL + '/candidats/getListeDocsClust', data, function (data) {
                mainTr.after(data);
                $('.doc_line_' + idDossier).slice(-1)[0].style.borderBottom =  '3px solid';
                btn.html(btn.html().replace('voir les pièces', 'cacher les pièces'));
            });
        }
        mainTr.toggleClass('active');
    },

    startNewLocationProject: function() {
        var conUuid = $(this).data('con-uuid');
        modalOuiNon('Souhaitez-vous réellement créer dossier pour ce candidat ?', 'Attention', function() {
            document.location.href = PROFIL + '/candidats/startNewLocationProject/' +  conUuid;
        });
    },

    voirListeZelok: function(e) {
        var btn = $(e.currentTarget);
        var foUuid = btn.data('folder-uuid');
        var mainTr = $('#tr-zelok-' + foUuid);
        if (mainTr.hasClass('active')) {
            // masquage des documents
            mainTr.removeClass('active');
            $('tr.doc_line_' + foUuid).remove();
            btn.html(btn.html().replace('cacher', 'voir'));
        } else {
            // affichage des documents;
            $('tr.candidat-location-project.active').removeClass('active')
                .find('button.voir_liste_zelok').html(btn.html().replace('cacher', 'voir'));
            mainTr.addClass('active');
            $('tr.doc_line').remove();
            $.ajax({
                url: PROFIL + '/candidats/getListeDocsZelok/' + foUuid
            }).done(function (data) {
                mainTr.after(data);
                if (data.trim()) {
                    $('.doc_line_' + foUuid).slice(-1)[0].style.borderBottom =  '3px solid';
                }
            });
            btn.html(btn.html().replace('voir', 'cacher'));
        }
    },

    rowAttributes: function(row, index) {
        var attributes = {
            'data-lp-uuid': row.lp_uuid,
            'data-agence-uuid': row.ag_uuid ? row.ag_uuid : '',
        }

        if (row.dossier && row.dossier.id) {
            attributes.id = 'tr_' + row.dossier.id;
        } else if (row.lp_uuid) {
            attributes.id = row.lp_uuid;
        }

        return attributes;
    },

    colNomFormatter: function(value, row) {
        var html;
        var nom = row.Nom ? row.Nom.toUpperCase(): '';
        var prenom = row.Prenom ? StringHelper.ucFirst(row.Prenom): '';
        if (row.typeDossier === 'zelok') {
            html = '<strong>' + nom + ' ' + prenom + ' (' + row.Email + ')'+
                '</strong>';
            if (row.colocataires.length) {
                row.colocataires.forEach(function(colocataire) {
                    html += '<br>' + colocataire.nom.toUpperCase() + ' ' + StringHelper.ucFirst(colocataire.prenom)
                        + ' (' + colocataire.email + ')';
                });
            }
        } else {
            html = nom + ' ' + prenom + '<br>' + ' (' + row.Email + ')';
        }

        if (row.TelephoneA || row.TelephonePortable) {
            html += '<div class="telephone">Tel : ';
            if (row.TelephoneA) {
                html +=  StringHelper.chunk_tel(row.TelephoneA);
            }
            if (row.TelephoneA && row.TelephonePortable) {
                html += ' / ';
            }
            if (row.TelephonePortable) {
                html += StringHelper.chunk_tel(row.TelephonePortable);
            }
            html += '</small></div>'
        }

        return html;
    },


    contactConseillerFormatter: function(value, row) {
        var ret = '';
        var cLoc = row.conseillerLocation;

        if (cLoc) {
            var prenom = cLoc.prenom ? cLoc.prenom.charAt(0).toUpperCase() + cLoc.prenom.slice(1).toLowerCase() : '';
            var nom = cLoc.nom ? cLoc.nom.toUpperCase() : '';

            ret = prenom + ' ' + nom;
        }
        var nomContact = row.Nom ? row.Nom.toUpperCase(): '';
        var prenomContact = row.Prenom ? StringHelper.ucFirst(row.Prenom): '';
        var hideClass = '';
        var privateNoteContent = '';
        if(row.lp_notePrivee) {
            privateNoteContent = StringHelper.base64decode(row.lp_notePrivee)
                .replace(/"/g, "&quot;");
        } else {
            hideClass = 'hide';
        }
        ret += '<button class="privateNote color-tenant ml-1 '+hideClass+'" data-lp-uuid="' + row.lp_uuid + '" data-toggle="tooltip" data-placement="top" data-contactname="'+prenomContact+' '+nomContact+'" title="'+privateNoteContent+'"><i class="fas fa-flag"></i></button>';
        return ret;
    },

    colAgenceFormatter: function(agenceNo, row) {
        if (! agenceNo && ! row.raison_sociale) {
            return '';
        }
        return [row.raison_sociale, agenceNo].filter(Boolean).join('<br>');
    },

    colDatesFormatter: function(value, row) {
        var html = '';

        if (row.lp_created_at) {
            html = '<small>Créé le ' + moment(row.lp_created_at).format('DD/MM/YY') + '</small>';
            if (row.lp_updated_at) {
                html += '<br><small>Modifié le ' + moment(row.lp_updated_at).format('DD/MM/YY') + '</small>';
            }
            if (row.dateEntree) {
                html += '<br><small>Entrée dans les lieux idéale ' + moment(row.dateEntree).format('DD/MM/YY') + '</small>';
            }
        }
        return html;
    },

    /**
     * Affiche le logo digiposte si c'est un dossier Digiposte
     *
     * @param {string} type Type du dossier (clust ou digipost)
     * @returns {string}
     */
    typeDossierFormatter: function(type) {
        switch (type) {
            case 'digiposte':
                return '<img src="/assets/img/logo-partenaire-digiposte.png"' +
                    ' width="50px" title="Digiposte" alt="Digiposte">';
            case 'clust':
                return '<img src="/assets/img/picto-zelok-z.png" width="50px"' +
                    ' title="Zelok" alt="Zelok">';
            case 'zelok':
                return '<img src="/assets/img/picto-zelok-fond-bleu.png" width="50px"' +
                    ' title="Zelok" alt="Zelok" class="img-dossier-zelok">';
        }
        return '';
    },

    prioriteFormatter: function(priorite, row) {
        var widget = '';
        if(row.lp_uuid) {
            widget += '<div class="prioritySelect" data-lp-uuid="' + row.lp_uuid + '"><span>'+((priorite>0)?priorite:'')+'</span>';
            var isDefault = '';
            if(!priorite) isDefault = 'selected="selected"';
            widget += '<select><option '+isDefault+' value=0>Aucune</option>';
            isDefault = '';
            for(var i=1; i<=5; i++) {
                isDefault = (!isDefault && priorite == i)?'selected="selected"':'';
                widget +='<option '+isDefault+' value='+i+'>'+i+'</option>';
            }
            widget +='</select></div>';

        }
        return widget;
    },

    colDocumentsFormatter: function(dossier, row, index) {
        if (dossier === null) {
            return null;
        }

        var btnVoirPieces  = '';
        var btnDownloadZip = '';
        var btnDownloadKycReports = '';
        var btnDownloadBailGenere = '';
        var btnProjectSynthese     = '';

        if (row.hasDocumentUploaded) {
            var url  = PROFIL + '/candidats/';
            if (row.con_uuid) {
                url += 'downloadDossierZip/' + row.con_uuid;
            } else {
                url += 'downloadDossierZipZelok/' + row.lp_uuid;
            }

            if (row.canDownloadZip == undefined || row.canDownloadZip == true) {
                btnDownloadZip =
                    '<a class="btn btn-icon" href="' + url + '" target="_blank" rel="noopener noreferrer">\
                    <i class="fal fa-file-archive fa-2x"></i>\
                    fichier zip\
                </a>';
            }
        }

        if (row.typeDossier === 'clust') {
            btnVoirPieces =
                '<button class="btn btn-icon voir_liste_clust" data-dossierid="' + row.clust_dossier_id + '">\
                <span class="icon icon-checklist"></span>\
                voir les pièces\
            </button>';
        } else {
            if (row.typeDossier === 'zelok') {
                if (row.foUuid) {
                    if (row.nbDocuments > 0) {
                        btnVoirPieces =
                            '<button class="btn btn-icon voir_liste_zelok" data-folder-uuid="' + row.foUuid + '">\
                        <span class="icon icon-checklist"></span>\
                        voir les pièces\
                    </button>';
                    } else {
                        btnVoirPieces = '';
                    }

                    // Récupération des contrôles KYC
                    if (row.controls){
                        btnDownloadKycReports = '<br>';
                        row.controls.forEach(function(data) {
                            btnDownloadKycReports = btnDownloadKycReports +
                                '<a class="btn btn-icon" href="/api/kyc/report/' + data.uuid + '" target="_blank" title="Télécharger le rapport KYC (PDF)">\
                            <span class="icon icon-checklist"></span>' + data.title +  '\
                        </a>';
                        });
                    }
                } else {
                    //affiche "voir tous les dossier" si un ou plusieurs membre(s)
                    if (row.colocataires.length > 0 ) {
                        btnVoirPieces =
                            '<button class="btn btn-icon btn-voir-membres-dossiers-zelok">\
                                <span class="icon icon-checklist"></span>\
                                voir tous les dossiers\
                            </button>';
                    } else {
                        btnVoirPieces =
                            '<button class="btn btn-icon btn-voir-membres-dossiers-zelok">\
                                <span class="icon icon-checklist"></span>\
                                voir les pièces\
                            </button>';
                    }
                }
            }
        }

        if (row.loc_statut === 'bail_genere') {
            btnDownloadBailGenere =
                '<a class="btn btn-icon" href="' + row.dossier.urlBailGenere + '" target="_blank">\
                <i class="fal fa-file-alt fa-2x"></i>\
                bail généré\
             </a>';
        }

        if (row.dossier && row.typeDossier === 'zelok') {
            btnProjectSynthese =
                '<a href="' + PROFIL + '/location_project/resume/' + row.lp_uuid + '"\
            class="btn " title="Synthèse" target="_blank">\
            <i class="fal fa-file-search fa-2x"></i> Synthèse\
        </a>';
        }

        return btnProjectSynthese + btnDownloadZip + btnVoirPieces + btnDownloadKycReports + btnDownloadBailGenere;
    },

    colStatusFormatter: function(value, row) {

        var dossier = (row && row.dossier) ? row.dossier : null;
        var isArchived = '';
        if (row && row.loc_isArchived && row.loc_isArchived === '1') {
            isArchived = '<div><small><small><i class="far fa-box-check"></i> Dossier archivé</small></small></div>';
        }

        if (dossier !== null) {
            var bgClass = ['valide', 'Validé', 'Transféré Solva', 'Validé Solva', 'Bail généré', 'Bail en production', 'Bail signé'].indexOf(dossier.statut.libelle) > -1
                ? 'bg-success' : '';
            if (dossier.canViewStatus != undefined && dossier.canViewStatus == false) {
                return '<div id="dossier_statut_' + (dossier.id ? dossier.id : '') + '">' +
                    (dossier.statut.libelle === 'valide' ? 'Validé' : dossier.statut.libelle) +
                    '</div>';
            }

            var kycBillingText = '';
            if (dossier.statut.kycBilling) {
                kycBillingText = '<small><small><i class="far fa-shield-check"></i> KYC effectué</small></small>';
            }

            return '<div id="dossier_statut_' + (dossier.id ? dossier.id : '') + '">' +
                (dossier.statut.libelle === 'valide' ? 'Validé' : dossier.statut.libelle) +
                ((row.isGliZelok == 'true')?'<br>GLI ZELOK':'')+
                '</div>' +
                '<div class="progress mt-1" style="height: 15px;">' +
                '<div class="progress-bar ' + bgClass + '" role="progressbar" style="width: ' + dossier.statut.taux_fourni + '%;"' +
                ' aria-valuenow="' +dossier.statut.taux_fourni + '" aria-valuemin="0" aria-valuemax="100">' +
                dossier.statut.taux_fourni + '%' +
                '</div>' +
                '</div>' + kycBillingText + isArchived;
        } else {
            return '' + isArchived;
        }
    },

    colActionsFormatter: function(value, row, index) {
        var btnInitProjetLocation = '';
        var btnTransfert = '';
        var btnFicheSolva = '';
        var btnSolvaDemanderComplements = '';
        var btnSolvaRefuserDossier = '';
        var btnSolvaValiderDossier = '';
        var btnSolvaAnnulerDossier = '';
        var btnAproveAll = '';
        var btnBailEnProduction  = '';
        var btnSignBail  = '';
        var btnChargerDocument = '';
        var btnRefuserProcedure = '';
        var btnCandidatureNonRetenue = '';
        var btnAddPrivateNote = '';
        var btnChangeArchiveState = '';
        var btnAffectationCandidat = '';
        var btnModificationCandidat = '';
        var btnCommentaireClient    = '';
        var btnExecuteKyc           = '';
        var badgeNbRelance          = '';
        var btnGenerateBail         = '';
        var btnProjectBail         = '';
        var $btnMenuActions;

        $btnMenuActions = $('<div class="">' +
            '<div class="dropdown btn-group">' +
            ' <button type="button" class="btn btn-lg"  data-toggle="dropdown" title="Menu Actions">' +
            '<i class="fas fa-ellipsis-v fa-fw"></i>' +
            '</button>' +
            ' <div class="dropdown-menu dropdown-menu-right">' +
            '<ul class="list-unstyled dropdown-menu--candidat-actions">' +
            '</ul>' +
            '</div>' +
            '</div>' +
            '</div>')
        ;

        if (USER.CAN_START_NEW_LOCATION_PROJECT && ! row.typeDossier) {
            btnInitProjetLocation =
                '<li>' +
                '<a role="button" class="dropdown-item mr-auto btn-init-location-project" title="Démarrer un dossier"' +
                '    data-con-uuid="' + row.con_uuid + '">' +
                '<i class="fal fa-layer-plus fa-fw"></i>' +
                ' Démarrer un dossier' +
                '</a>' +
                '</li>';
        }

        // bouton "Générer un bail"
        if (
            row.canGenerateBail
            && (PROFIL === 'agent_immo' || IS_CONSEILLER_LOC_ADMIN_MGL)
            && row.typeDossier === 'zelok'
            && row.loc_statut !== 'bail_genere'
            && ['valide', 'Validé', 'Validé Solva', 'bail_genere'].indexOf(row.dossier.statut.libelle) > -1
        ) {
            btnGenerateBail =
                '<li>\
                    <a role="button" class="dropdown-item btn-generateur-de-bail"\
                       href="' + PROFIL + '/generateur_de_bail/accueil/index/zelok/' + row.lp_uuid + '"\
                   title="Générer un bail">\
                    <i class="far fa-address-book fa-fw"></i> Générer un bail\
                </a>\
            </li>';
        }

        if (
            row.canSignBail
            && row.dossier
            && (row.dossier.statut.libelle === 'valide' || row.dossier.statut.libelle === 'Validé Solva' || row.dossier.statut.libelle === 'Bail généré')
        ) {
            var depotType = '';
            var depotUuid = '';
            if (row.typeDossier === 'zelok') {
                depotType = row.typeDossier;
                depotUuid = row.lp_uuid;
            } else {
                depotType = 'contact';
                depotUuid = row.con_uuid;
            }
            var depoName = row.Nom + ' ' + row.Prenom + ' (' + row.Email + ')';
            btnProjectBail =
                '<li>' +
                '<a role="button" class="dropdown-item btn-project-bail"data-depot-name="' + depoName + '"  data-depot-type="' + depotType + '" data-depot-uuid="' + depotUuid + '" title="Bail - parcours signature électronique">\
            <i class="fal fa-file-signature fa-fw"></i>\
             Bail - parcours signature électronique \
        </a>' +
                '</li>';
        }

        if (row.typeDossier === 'clust') {
            btnChargerDocument =
                '<li>' +
                '<a class="dropdown-item upload_docs" href="' + PROFIL + '/candidats/dossier/' + value + '" title="charger des documents">\
                <img src="assets/img/clust/upload.svg" alt="charger des documents" width="15">\
                Charger des documents\
            </a>' +
                '</li>';
        } else if (row.typeDossier === 'zelok' && row.userCanUploadDocs) {
            btnChargerDocument =
                '<li>' +
                '<a class="dropdown-item upload_docs" href="' + PROFIL + '/candidats/dossierZelok/' + row.foUuid + '"\
                title="charger des documents">\
                <i class="fal fa-file-upload fa-fw" title="Charger des documents"></i>\
                Charger des documents\
            </a>' +
                '</li>';
        }


        if (row.dossier) {
            if (row.loc_statut === null && (row.dossier.statut.libelle !== 'Validé' && row.dossier.statut.libelle !== 'valide')) {
                if (row.typeDossier === 'clust') {
                    btnAproveAll =
                        '<li>' +
                        '<button class="dropdown-item approve_all" data-conuuid="' + row.con_uuid + '" title="Approuver toutes les pièces">\
                          <img src="assets/img/clust/approved.svg" alt="Approuver toutes les pièces" width="15">\
                           Approuver toutes les pièces\
                       </button>' +
                        '</li>';
                } else if (row.typeDossier === 'zelok') {
                    btnAproveAll =
                        '<li>' +
                        '<button class="dropdown-item approve_all" data-lp-uuid="' + row.lp_uuid + '" title="Approuver toutes les pièces">\
                        <img src="assets/img/clust/approved.svg" width="15">\
                        Approuver toutes les pièces\
                     </button>' +
                        '</li>';
                } else if (
                    PROFIL === 'agent_immo' && row.typeDossier === 'digiposte'
                    && row.dossier.statut.libelle === 'Complété' && row.canGenerateBail
                ) {
                    btnGenerateBail =
                        '<li>' +
                        '<a role="button" class="dropdown-item btn-generateur-de-bail"' +
                        ' href="agent_immo/generateur_de_bail/accueil/index/digiposte/' + row.user_procedure_id + '"' +
                        ' title="Générer un bail">\
                            <i class="far fa-address-book fa-fw"></i>\
                         </a>' +
                        '</li>';
                }
            } else if (
                (row.loc_statut !== 'transfere_solva' && row.loc_statut !== 'valide_solva')
                && (row.dossier.statut.libelle === 'Validé' || row.dossier.statut.libelle === 'valide')
                && CAN_TRANSFERT_SOLVA
            ) {
                btnTransfert =
                    '<li>' +
                    '<a role="button" class="dropdown-item transfert-solva" data-gli="0" data-id="' + value + '" data-lp-uuid="' + row.lp_uuid + '"' +
                    ' data-dossierid="' + row.clust_dossier_id + '" title="Transfert Solva">\
                    <i class="far fa-paper-plane fa-fw"></i>  Transfert Solva\
                 </a>' +
                    '</li>';
                if(GLI_ZELOK_ALLOWED) {
                    btnTransfert +=
                        '<li>' +
                        '<a role="button" class="dropdown-item transfert-solva-gli-zelok" data-gli="1" data-id="' + value + '" data-lp-uuid="' + row.lp_uuid + '"' +
                        ' data-dossierid="' + row.clust_dossier_id + '" title="Transfert Solva">\
                        <i class="fas fa-file-certificate"></i>  Transfert Solva GLI ZELOK\
                     </a>' +
                        '</li>';
                }
            } else if (
                (row.dossier.statut.libelle === 'Validé' && !CAN_TRANSFERT_SOLVA)
                || row.dossier.statut.libelle === 'Transféré Solva'
                || row.dossier.statut.libelle === 'Validé Solva'
                || row.dossier.statut.libelle === 'Bail en production'
            ) {
                if (row.loc_statut !== 'bail_genere') {
                    btnSignBail =
                        '<li>' +
                        '<a role="button" class="dropdown-item btn-sign-bail" data-id="' + value + '"  title="Bail signé">\
                        <i class="fas fa-file-signature fa-fw"></i> Bail signé\
                     </a>' +
                        '</li>';
                    if (row.loc_statut !== 'bail_en_production') {
                        btnBailEnProduction =
                            '<li>' +
                            '<a role="button" class="dropdown-item btn-bail-en-production" data-con-id="' + value + '"  title="Bail en production">' +
                            '<i class="far fa-file-signature fa-fw"></i> Bail en production' +
                            '</a>' +
                            '</li>';
                    }
                }
            }

            /*   if (row.typeDossier === 'zelok' && row.dossier.statut.libelle === 'Complété') {
                   btnAproveAll =
                       '<li>' +
                       '<button class="dropdown-item approve_all" data-lp-uuid="' + row.lp_uuid + '" title="Approuver toutes les pièces">\
                           <img src="assets/img/clust/approved.svg" alt="Approuver toutes les pièces" width="15"> Approuver toutes\
                            les pièces \
                        </button>' +
                       '</li>';
               }*/

            if (row.typeDossier === 'zelok' && row.canExecuteKyc) {
                btnExecuteKyc =
                    '<li>' +
                    '<a role="button" class="dropdown-item btn-execute-kyc" data-lp-uuid="' + row.lp_uuid + '" title="Contrôle KYC du dossier">\
                   <small><i class="far fa-file-medical-alt fa-fw"></i></small> Contrôle KYC du dossier\
                 </a>' +
                    '</li>';
            }
        }

        if (row.typeDossier === 'zelok' && row.lp_uuid) {
            if(row.lp_notePrivee) {
                var title = 'Modifier la note privée';
            } else {
                var title = 'Ajouter une note privée';
            }
            btnAddPrivateNote =
                '<li>' +
                '<button class="dropdown-item btn-add-private-note mr-auto" data-privatenote="' + row.lp_notePrivee + '" data-contactid="' + value + '" data-lp-uuid="' + row.lp_uuid + '"' +
                ' title="'+title+'">' +
                '<i class="fas fa-pen fa-fw"></i>' +
                '<span class=""> '+title+'</span>' +
                '</button>' +
                '</li>';
        }
        if (row.typeDossier === 'digiposte' && row.dg_etat == 2) {
            btnRefuserProcedure =
                '<li>' +
                '<button class="dropdown-item btn-refuser-demarche mr-auto" data-upid="' + row.user_procedure_id + '"' +
                ' title="Refuser la démarche">' +
                '<i class="fad fa-exclamation-triangle fa-fw"></i>' +
                '<span class=""> Refuser la démarche</span>' +
                '</button>' +
                '</li>';
        } else if (row.dossier && row.typeDossier === 'zelok' && (
            (row.dossier.statut.libelle === 'Complété' && row.dossier.statut.taux_fourni == 100 ) ||
            row.dossier.statut.libelle === 'Validé Solva' ||
            row.dossier.statut.libelle === 'Refusé Solva' ||
            row.dossier.statut.libelle === 'valide'
        )
        ) {
            var nomContact = row.Nom ? row.Nom.toUpperCase(): '';
            var prenomContact = row.Prenom ? StringHelper.ucFirst(row.Prenom): '';
            btnCandidatureNonRetenue =
                '<li>' +
                '<button class="dropdown-item btn-candidature-non-retenue mr-auto" data-contactname="'+prenomContact+' '+nomContact+'" data-contactid="'+value+'" data-lpuuid="' + row.lp_uuid + '"' +
                ' title="Candidature non retenue">' +
                '<i class="fal fa-exclamation-triangle fa-fw"></i>' +
                '<span class=""> Candidature non retenue</span>' +
                '</button>' +
                '</li>';
        }


        if (row.con_uuid) {
            if (row.typeDossier === 'zelok' /*&& row.status === 'Complété'*/) {
                btnAproveAll =
                    '<li>' +
                    '<button class="dropdown-item approve_all" data-conuuid="' + row.con_uuid + '" title="Approuver toutes les pièces">\
                    <img src="assets/img/clust/approved.svg" width="15"> Approuver toutes les pièces\
                 </button>' +
                    '</li>';
            }
        }

        if ((row.dossier || (row.dossier === null && row.con_uuid)) && row.loc_isArchived === '0') {
            btnChangeArchiveState =
                '<li>' +
                '<a href="' + PROFIL + '/candidats/archive/' + row.id + '"\
                class="dropdown-item archive_contact" data-id="' + row.id + '" title="Archiver le dossier">\
                <i class="far fa-cube fa-fw"></i><span class=""> Archiver le dossier</span>\
            </a>' +
                '</li>';
        } else if ((row.dossier || (row.dossier === null && row.con_uuid)) && row.loc_isArchived === '1') {
            btnChangeArchiveState =
                '<li>' +
                '<a href="' + PROFIL + '/candidats/unarchive/' + row.id + '"\
                class="dropdown-item unarchive_contact" data-id="' + row.id + '" title="Désarchiver le dossier">\
                Désarchiver le dossier \
                <i class="far fa-box-open fa-fw"></i>\
            </a>' +
                '</li>';
        }

        if (['transfere_solva', 'demande_solva', 'refus_solva', 'valide_solva'].indexOf(row.loc_statut) > -1) {
            btnFicheSolva =
                '<li>' +
                '<a href="' + PROFIL + '/candidats/ficheSolva/' + value + '" target="_blank"\
                class="dropdown-item fiche-solva" data-id="' + value + '" title="Télécharger la fiche `solva`">\
                <i class="far fa-file-spreadsheet fa-fw"></i>\
                 Télécharger la fiche `solva'+((row.isGliZelok=='true')?' GLI':'')+'`\
            </a>' +
                '</li>';

            if ((IS_ROLE_SOLVA || PROFIL === 'admin') && (row.loc_statut === 'valide_solva' || row.loc_statut === 'refuse_solva' || row.loc_statut === 'transfere_solva')) {
                btnSolvaAnnulerDossier =
                    '<li>' +
                    '<a data-contactid="'+value+'" data-contactname="'+prenomContact+' '+nomContact+'" role="button" class="dropdown-item btn-solva-gli-annuler-dossier"' +
                    ' data-lp-uuid="' + (row.lp_uuid ? row.lp_uuid : '') + '"\
                         data-upid="' + (row.user_procedure_id ? row.user_procedure_id : '') + '"\
                         title="Solva : annuler la demande">\
                    <i class="fal fa-thumbs-down fa-fw"></i>\
                     Solva : annuler la demande\
                 </a>';

            }

            if ((IS_ROLE_SOLVA || PROFIL === 'admin') && row.loc_statut === 'transfere_solva') {
                var nomContact = row.Nom ? row.Nom.toUpperCase(): '';
                var prenomContact = row.Prenom ? StringHelper.ucFirst(row.Prenom): '';
                if(row.isGliZelok == 'true') {
                    btnSolvaRefuserDossier =
                        '<li>' +
                        '<a data-contactid="'+value+'" data-contactname="'+prenomContact+' '+nomContact+'" role="button" class="dropdown-item btn-solva-gli-refuser-dossier"' +
                        ' data-lp-uuid="' + (row.lp_uuid ? row.lp_uuid : '') + '"\
                         data-upid="' + (row.user_procedure_id ? row.user_procedure_id : '') + '"\
                         title="Étude de solva GLI : refuser l\'ensemble du dossier">\
                    <i class="fal fa-thumbs-down fa-fw"></i>\
                     Étude de solva GLI : refuser l\'ensemble du dossier\
                 </a>' +
                        '</li>';
                    var validMethod = (row.lp_uuid ? row.lp_uuid  : row.user_procedure_id );

                    btnSolvaValiderDossier =
                        '<li>' +
                        '<a data-contactid="'+value+'" data-contactname="'+prenomContact+' '+nomContact+'" data-lp-uuid="' + validMethod + '"\
                    class="dropdown-item btn-solva-gli-valider-dossier"\
                    title="Étude de solva GLI : valider l\'ensemble du dossier">\
                    <i class="fal fa-box-check fa-fw"></i>\
                     Étude de solva GLI : valider l\'ensemble du dossier\
                </a>' +
                        '</li>';
                } else {
                    btnSolvaRefuserDossier =
                        '<li>' +
                        '<a data-contactname="'+prenomContact+' '+nomContact+'" role="button" class="dropdown-item btn-solva-refuser-dossier"' +
                        ' data-lp-uuid="' + (row.lp_uuid ? row.lp_uuid : '') + '"\
                         data-upid="' + (row.user_procedure_id ? row.user_procedure_id : '') + '"\
                         title="Étude de solvabilité : refuser l\'ensemble du dossier">\
                    <i class="fal fa-thumbs-down fa-fw"></i>\
                     Étude de solvabilité : refuser l\'ensemble du dossier\
                 </a>' +
                        '</li>';
                    var validMethod = (row.lp_uuid ? row.lp_uuid  : row.user_procedure_id );

                    btnSolvaValiderDossier =
                        '<li>' +
                        '<a data-contactname="'+prenomContact+' '+nomContact+'" data-lp-uuid="' + validMethod + '"\
                    class="dropdown-item btn-solva-valider-dossier"\
                    title="Étude de solvabilité : valider l\'ensemble du dossier">\
                    <i class="fal fa-box-check fa-fw"></i>\
                     Étude de solvabilité : valider l\'ensemble du dossier\
                </a>' +
                        '</li>';
                }

            }
        }

        if (
            (IS_ROLE_SOLVA || PROFIL === 'admin')
            && (
                row.status === 'Transféré Solva'
                || (row.loc_statut === 'transfere_solva' && row.typeDossier === 'digiposte')
            )
        ) {
            // TODO : #1840
            // btnSolvaDemanderComplements =
            //     '<button class="btn btn-solva-demander-complements"' +
            //            ' data-con-uuid="' + row.con_uuid + '"' +
            //            ' data-upid="' + (row.user_procedure_id ? row.user_procedure_id : '') + '"\
            //              title="Étude de solvabilité : demander des informations complémentaires au candidat">\
            //         <i class="fal fa-tasks fa-lg"></i>\
            //      </button>';
        }

        if (row.canBeAssigned && row.con_uuid) {
            btnAffectationCandidat =
                '<li>' +
                '<a role="button" class="dropdown-item btn-affectation-client" data-conuuid="' + row.con_uuid + '" title="Affecter candidat">' +
                '<i class="fa fa-user-chart fa-fw"></i><span class=""> Affecter candidat</span>' +
                '</a>' +
                '</li>';
        }

        if (row.con_uuid) {
            btnModificationCandidat =
                '<li>' +
                '<a class="dropdown-item edit_candidat" title="Modifier les infos du candidat"' +
                ' href="' + PROFIL + '/candidats/edit/' + row.con_uuid + '" >' +
                '<i class="fas fa-pen fa-fw"></i><span class=""> Modifier les infos du candidat</span>' +
                '</a>' +
                '</li>';
        }

        if (row.con_uuid) {
            btnCommentaireClient =
                '<li>' +
                '<a role="button" class="dropdown-item btn-commentaire-client"\
                         data-con-uuid="' + row.con_uuid  +'"\
                     title="Envoyer un message au candidat locataire">\
                <i class="far fa-comment fa-fw"></i><span class=""> Envoyer un message au candidat locataire</span>\
             </a>' +
                '</li>';
        }

        if (row.loc_nbRelances && +row.loc_nbRelances > 0) {
            badgeNbRelance =
                '<button class="dropdown-item" disabled>' +
                '<span class="badge badge-pill badge-secondary" title="Nombre de relances">' +
                row.loc_nbRelances +
                '</span>' +
                ' relance(s)' +
                '</button>'
            ;
        }

        if (IS_ROLE_SOLVA) {
            btnAproveAll = '';
            btnRefuserProcedure = '';
            btnCandidatureNonRetenue = '';
            btnAddPrivateNote = '';
            btnTransfert = '';
            btnCommentaireClient = '';
            btnAffectationCandidat = '';
            btnModificationCandidat = '';
        }



        if (row.loc_isArchived && row.loc_isArchived == 1) {
            if (row.typeDossier === 'zelok' && row.con_uuid) {
                return [btnChangeArchiveState].join('');
            } else {
                return [
                    btnChangeArchiveState,
                ].join('');
            }
        }

        if(IS_TETE_DE_RESEAU || IS_MANDATAIRE) {
            btnGenerateBail = '';
            btnExecuteKyc = '';
            btnProjectBail = '';
        }

        if(true === IS_CONSEILLER_LOC_ADMIN_MGL) {
            var buttons = btnGenerateBail;
        } else {
            var buttons = [
                btnInitProjetLocation,
                btnChargerDocument,
                btnAproveAll,
                btnRefuserProcedure,
                btnCandidatureNonRetenue,
                btnAddPrivateNote,
                btnTransfert,
                btnFicheSolva,
                btnSolvaDemanderComplements,
                btnSolvaRefuserDossier,
                btnSolvaValiderDossier,
                btnSolvaAnnulerDossier,
                btnGenerateBail,
                btnProjectBail,
                btnBailEnProduction,
                btnSignBail,
                btnCommentaireClient,
                btnAffectationCandidat,
                btnModificationCandidat,
                btnExecuteKyc,
                btnChangeArchiveState,
                badgeNbRelance,
            ].join('');
        }
        if(buttons.length > 0) {
            $btnMenuActions.find('.dropdown-menu--candidat-actions').append(
                buttons
            );
            return $btnMenuActions.html();
        } else {
            return '';
        }
    },

    colOriginsFormatter: function(value, row, index) {
        if (value === 'FO') {
            return '<i class="fas fa-check green-text"></i>';
        }
        if (value === 'BO') {
            return '.';
        }
        if (value === 'BATCH') {
            return '.';
        }

        return '.';
    },

    /**
     * Déplacement automatique vers le dossier passé dans l'url
     */
    autoScrollToLocationProject: function() {
        if (document.location.hash) {
            var $tr = $(document.location.hash);
            if ($tr.length) {
                $('html,body').animate({
                    scrollTop: $tr.offset().top
                }, 'slow');
                history.pushState("", document.title, window.location.pathname + window.location.search);
            }
        }
        $('.table_clust').off('load-success.bs.table');
    },
};

/**
 * Modal edition de la note privée avec possibilité de suppression
 * @param e
 */
function openUpdatePrivateNoteModal(e) {
    e.stopImmediatePropagation();
    var $button     = $(e.currentTarget);
    var lpUuid      = $button.data('lp-uuid');
    var contactName = $button.data('contactname');
    var content     = $button.attr('data-original-title');

    var $updatePrivateNoteModal = $('#update-private-note-modal');

    $('#update-private-note-modal h3 span').html(contactName);
    $('#update-private-note-modal textarea').val(content);
    $('#update-private-note-modal .content').html(StringHelper.nl2br(content));

    /* Visualisation & actions edition, suppression */
    var $editMode = $('#btn-update-private-note-modal-edit, ' +
        '#update-private-note-modal .content, ' +
        '#btn-update-private-note-modal-cancel');

    /* Confirmation de la MAJ */
    var $updateConfirmMode = $('#update-private-note-modal form, ' +
        '#btn-update-private-note-modal-confirm, ' +
        '#update-private-note-modal textarea, ' +
        '#btn-update-private-note-modal-cancel-confirm');

    function getNoteTitleAction(note) {
        var title = 'Ajouter une note privée';
        if(note) {
            title = 'Modifier la note privée';
        }
        return title;
    }

    function updateNoteButton(note) {
        if(note) {
            $button.attr('data-original-title', note.replace(/"/g, "&quot;"));
        } else {
            $button.attr('data-original-title','');
            $button.addClass('hide');
        }
    }

    function showSpinnerUpdateModal() {
        $('#btn-update-private-note-modal-cancel-confirm, ' +
            '#btn-update-private-note-modal-confirm, ' +
            '#btn-update-private-note-modal-cancel').hide();
        $('#btn-update-private-note-modal-confirm-spinner').show();
    }

    function hideSpinnerUpdateModal() {
        $('#btn-update-private-note-modal-confirm-spinner').hide();
    }

    function updateNoteModal(note){
        $('#update-private-note-modal .content').html(StringHelper.nl2br(note));
        $('#update-private-note-modal textarea').val(note).hide();
    }

    function updateNoteMenuElement(note) {
        var title = getNoteTitleAction(note);
        var menuElement =  $('tr[data-lp-uuid="' + lpUuid + '"]').find('.btn-add-private-note');
        menuElement.attr('title', title);
        menuElement.find('span').html(title);
        if(note) {
            menuElement.data('privatenote', StringHelper.base64encode(note));
        } else {
            menuElement.data('privatenote', '');
        }
    }

    function setDeleteButton() {
        var note = $('#update-private-note-modal textarea').val();
        if(note) {
            $('#btn-update-private-note-modal-delete').show();
        } else {
            $('#btn-update-private-note-modal-delete').hide();
        }
    }

    /**  Initialisation */

    $updatePrivateNoteModal.modal();
    $updateConfirmMode.hide();
    hideSpinnerUpdateModal();
    $editMode.show();
    setDeleteButton();
    /* Annulation edition */
    $('#btn-update-private-note-modal-cancel-confirm').on('click', function(e) {
        $updateConfirmMode.hide();
        $editMode.show();
    });

    /* EDITION */
    $('#btn-update-private-note-modal-edit').on('click', function() {
        $editMode.hide();
        $updateConfirmMode.show();
    });

    /**
     * Suppression de la note privée
     */
    $('#btn-update-private-note-modal-delete').on('click', function () {
        $updatePrivateNoteModal.modal('hide');
        modalOuiNonV2('Voulez-vous supprimer cette note privée ?', 'Attention', function (callbackOuiNon) {
            var note = '';
            var callback = {
                stop: function(response) {
                    updateNoteMenuElement(note);
                    updateNoteButton(note);
                    updateNoteModal(note);
                    callbackOuiNon.stop();
                    hideSpinnerUpdateModal();
                    $editMode.show();
                },
                start: callbackOuiNon.start
            }
            ajaxPrivateNote(note, lpUuid, callback);
        }, function () {
            $updatePrivateNoteModal.modal('show');
        });
    });

    /**
     * Mise à jour de la note privée
     */
    $('#btn-update-private-note-modal-confirm' ).off().on('click', function () {
        var note = $('#update-private-note-modal textarea').val();

        var callback = {
            stop: function(response) {
                updateNoteMenuElement(note);
                updateNoteButton(note);
                $updatePrivateNoteModal.modal('hide');
                updateNoteModal(note);
                hideSpinnerUpdateModal();
                $editMode.show();
            },
            start: function() {
                showSpinnerUpdateModal();
            }
        }
        ajaxPrivateNote(note, lpUuid, callback);
    });

}


var $tableClust = $('.table_clust');

//Trigger si on a un truc en get (= clic depuis admin/candidats)
var did = $tableClust.data('did');
if (did != 0) {
    $('.voir_liste_clust[data-dossierid=' + did + ']').trigger('click');
}

$('#table-candidats-locataires').on('load-success.bs.table', function (e, arg1, arg2) {
    $('[data-toggle="tooltip"]').tooltip();
    $('button.privateNote').on('click',openUpdatePrivateNoteModal);
    $('.prioritySelect select').hide();
    $('td.colPriorite').attr('title', 'Cliquer ici pour définir une priorité sur ce dossier');
});


